<div class="createAudit">
  <p-dialog header="Header" (onHide)="dialogClose()" [modal]="true" [(visible)]="isShowModal"
            [style]="{width: '35.5rem'}">
    <ng-template pTemplate="header">
      <div class="d-flex align-items-center" [style]="{paddingBottom: '0px'}">
        <div class="left-border left-border-bg"></div>
        <div class="d-flex-d-column margin-left-5">
          <span class="user-title-text">User Activity Search</span>
        </div>
      </div>
    </ng-template>
    <p-divider></p-divider>

    <div>
      <p class="para-text">
        View all user activity logs and audit trails in one place.
      </p>
      <p-divider></p-divider>
      <div class="input-box">
        <label class="mb-3 label-bold">User name value to search for</label>
        <span class="p-input-icon-right input-container">
          <input class="input-text"
                 type="text"
                 pInputText
                 placeholder="SomeUserName"
                 [(ngModel)]="userValueToSearchFor">
        </span>
      </div>
      <div class="input-box">
        <label class="mb-3">
          Select Audit Types (I)nsert, (U)pdate, (D)elete
        </label>
        <span class="p-input-icon-right input-container">
          <p-multiSelect [options]="auditTypes"
                         optionLabel="name"
                         defaultLabel="Choose one"
                         display="chip"
                         styleClass="horizontal-multiselect"
                         [(ngModel)]="selectedAuditTypes">
          </p-multiSelect>
        </span>
      </div>
      <p-divider></p-divider>
      <div class="input-dropdown-with-capsule-values">
        <div class="input-box">
          <label class="mb-3">
            Created By Column Name
          </label><br>
          <span class="p-input-icon-right input-container">
            <p-dropdown [options]="columns"
                        optionLabel="Name"
                        placeholder="Choose one"
                        [(ngModel)]="selectedCreatedByColumn"></p-dropdown>
          </span>
        </div>
      </div>
      <p-divider></p-divider>
      <div class="input-dropdown-with-capsule-values">
        <div class="input-box">
          <label class="mb-3">
            Updated By Column Name
          </label><br>
          <span class="p-input-icon-right input-container">
            <p-dropdown [options]="columns"
                        optionLabel="Name"
                        placeholder="Choose one"
                        [(ngModel)]="selectedUpdatedByColumn"></p-dropdown>
          </span>
        </div>
      </div>
    </div>

    <!-- Bottom buttons -->
    <div class="btn-box">
      <!-- Create button -->
      <p-button [loading]="false"
                class="filled-btn"
                label="Create"
                (onClick)="startSearch()" severity="secondary"></p-button>

      <!-- Add reset & Cancel button code here  -->
      <p-button class="outlined-btn reset-btn"
                [loading]="false"
                label="Reset"
                (onClick)="resetSearch()"></p-button>
    </div>
  </p-dialog>
</div>
